import { render, staticRenderFns } from "./CardPP.vue?vue&type=template&id=07a78d36&scoped=true"
import script from "./CardPP.vue?vue&type=script&lang=js"
export * from "./CardPP.vue?vue&type=script&lang=js"
import style0 from "./CardPP.vue?vue&type=style&index=0&id=07a78d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a78d36",
  null
  
)

export default component.exports